import React, { useState } from "react";
import { IonSelect, IonSelectOption } from "@ionic/react";
import "./InputTypes.css";
type componentProps = {
  question: string;
  question_id: number;
  options: string;
  questionno?: number;
  requiredmessage?: boolean;
  answer?: string;
  allowHtmlQuestion?: any;
  placeholder?: any;
  interfaceCssClass?: string;
  otherLabel?: string;
};
const InputTypeSelectOther: React.FC<componentProps> = (Props) => {
  const {
    question,
    answer,
    question_id,
    options,
    questionno,
    requiredmessage,
    allowHtmlQuestion,
    placeholder,
    interfaceCssClass,
    otherLabel = "Other",
  } = Props;
  const [selectAnswerValue, setSelectAnswerValue] = useState<any>(answer);
  const [otherValue, setOtherValue] = useState<string>("");

  const isOther = selectAnswerValue === otherLabel;
  const answerName = "answer_" + question_id.toString();

  return (
    <div className="take-test-question">
      <div className="take-test-question__label">
        {allowHtmlQuestion ? (
          <span
            dangerouslySetInnerHTML={{
              __html: question,
            }}
          ></span>
        ) : (
          <>{question}</>
        )}
      </div>
      <IonSelect
        mode="ios"
        {...(isOther ? {} : { name: answerName })}
        placeholder={placeholder ? placeholder : "--Select--"}
        className={
          requiredmessage == true
            ? "form-input-styles-error"
            : "form-group__input-styles"
        }
        value={selectAnswerValue}
        onIonChange={(e: any) => setSelectAnswerValue(e.detail.value)}
        {...(interfaceCssClass
          ? { interfaceOptions: { cssClass: interfaceCssClass } }
          : {})}
      >
        {options &&
          options.split("||").map((data: any, index: number) => (
            <IonSelectOption key={index} value={data}>
              {data}
            </IonSelectOption>
          ))}
      </IonSelect>
      {isOther && (
        <input
          type="text"
          name={answerName}
          maxLength={25}
          placeholder="Please specify"
          className={
            requiredmessage == true
              ? "form-group__input-styles form-input-styles-error"
              : "form-group__input-styles"
          }
          value={otherValue}
          onChange={(e: any) => setOtherValue(e.target.value.slice(0, 25))}
          style={{ marginTop: "8px" }}
        ></input>
      )}
      {requiredmessage == true && (
        <div className="error-message">This field is required.</div>
      )}
    </div>
  );
};

export default InputTypeSelectOther;
